import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS, LOCAL_STORAGE_KEYS, ROUTE_PATHS } from '@constants';
import { Icon } from '@ui';
import { observer } from 'mobx-react';
import InviteDeveloperModal from '../../pages/Register/components/InviteDeveloper/components/InviteDeveloperModal';
import {
    ButtonsContainer,
    CloseButton,
    ContentContainer,
    DescriptionText,
    Divider,
    HeaderContainer,
    HeaderRow,
    InviteDeveloperButton,
    ModalContent,
    ModalTitle,
    SetupMyselfButton,
    StyledModal,
    TextContainer
} from './styled';

export const DemoProductsModal = observer(({ setIsModalOpen, isModalOpen }) => {
    const navigate = useNavigate();
    const [isInviteDeveloperModalOpen, setIsInviteDeveloperModalOpen] = useState(false);

    const handleClose = () => {
        setIsModalOpen(false);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.SHOW_DEMO_PRODUCTS_MODAL);
    };

    const handleSetupMyself = () => {
        handleClose();
        navigate(ROUTE_PATHS.INTEGRATIONS_SETTINGS);
    };

    const handleInviteDeveloper = () => {
        handleClose();
        setIsInviteDeveloperModalOpen(true);
    };

    return (
        <React.Fragment>
            <StyledModal
                width={630}
                open={isModalOpen}
                onCancel={handleClose}
                footer={null}
                maskClosable={false}
                closable={false}
                destroyOnClose
            >
                <ModalContent data-e2e='demo-products-modal_content'>
                    <HeaderContainer>
                        <HeaderRow>
                            <ModalTitle data-e2e='demo-products-modal_title' level={2}>
                                Your campaign is pre-launched
                            </ModalTitle>
                            <CloseButton type='noStyle' onClick={handleClose}>
                                <Icon size='24px' color={COLORS.$gray60Black} component={() => <Icon.CloseIcon />} />
                            </CloseButton>
                        </HeaderRow>
                        <Divider />
                    </HeaderContainer>

                    <ContentContainer>
                        <TextContainer>
                            <DescriptionText type='descriptor1' data-e2e='demo-products-modal_description'>
                                This campaign is pending until you connect your store. <br />
                                Once your developers complete the setup, it will go live automatically.
                            </DescriptionText>
                        </TextContainer>
                    </ContentContainer>

                    <ButtonsContainer>
                        <SetupMyselfButton
                            onClick={handleSetupMyself}
                            type='default'
                            data-e2e='demo-products-modal_set-up-myself_btn'
                        >
                            Set Up Myself
                        </SetupMyselfButton>
                        <InviteDeveloperButton
                            onClick={handleInviteDeveloper}
                            type='primary'
                            data-e2e='demo-products-modal_invite-developer_btn'
                        >
                            Invite Developer
                        </InviteDeveloperButton>
                    </ButtonsContainer>
                </ModalContent>
            </StyledModal>
            <InviteDeveloperModal
                isModalOpen={isInviteDeveloperModalOpen}
                setIsModalOpen={setIsInviteDeveloperModalOpen}
                closeWithoutNavigate
            />
        </React.Fragment>
    );
});

export default DemoProductsModal;
